// /*
//  * Name: Scaffolding-WP
//  * Author: Craig Cooper
//  * Author URI: http://craigomatic.co.uk
//  * Description: A bare bones front-end framework for Wordpress
//  * Version: 0.1
//  */

selectBorders();
swatchToolTips();
// variablePrice();
closeNotices();

function selectBorders() {
	const hiddenSelect = Array.from(document.querySelectorAll(".thwvs-select"));
	hiddenSelect.forEach((arrayElement, index) => {
		if (window.getComputedStyle(hiddenSelect[index]).display === "none") {
			hiddenSelect[index].parentElement.parentElement.classList.remove("variation__options--select");
		}
	});
}

function swatchToolTips() {
	const swatches = document.querySelectorAll(".thwvsf-checkbox");

	swatches.forEach((arrayElement, i) => {
		const variation = swatches[i].getAttribute("data-value");
		const newElement = document.createElement("span");
		const toolTipText = document.createTextNode(variation);
		newElement.classList.add("tooltip");
		newElement.appendChild(toolTipText);
		swatches[i].insertAdjacentElement("beforeend", newElement);
	});
}

function closeNotices(){
	
	// ensure that we are not working against a cached list of elements
	const closers = document.querySelectorAll("[data-close]");
	let i;
	
	for (i = 0; i < closers.length; i++) {
		const trigger = closers[i];

		trigger.addEventListener("click", (e) => {
			e.stopPropagation();
			
			if (e.target.classList.contains("woocommerce-notices-wrapper") && !e.target.classList.contains("wc-block-components-notice-banner")) {
				console.log("overlay clicked");
				e.target.classList.add("hidden");
			} else if (e.target.classList.contains("notice__close")) {
				e.target.closest(".woocommerce-notices-wrapper").classList.add("hidden");
			}
		});
	}
}